module.exports = __webpack_public_path__ + "img/5f_r_torikoma@2x.7dc5df95.jpg";